<template>
    <list-cell-text v-if="!appointment">
        <template #content>
            Geen afspraak
        </template>
    </list-cell-text>

    <list-cell-text v-else>
        <template #icons="{ bindings }">
            <svg-icon
                :size="bindings.iconSize"
                :icon="IconCalendarMonth"
                :color="Color.gray400"
            />
            <svg-icon
                :size="bindings.iconSize"
                :icon="IconSchedule"
                :color="Color.gray400"
            />
        </template>

        <template #content>
            <text-decorator :size="FontSize.sm">
                {{ dateLabel }}
            </text-decorator>

            <text-decorator :size="FontSize.sm" :color="Color.gray400">
                {{ timeLabel }} uur
            </text-decorator>
        </template>
    </list-cell-text>
</template>

<script setup lang="ts">
    import { computed } from 'vue';
    import { Color, FontSize, ListCellText, TextDecorator } from '@keyvue/one-ui';
    import type { Appointment } from '@keyvue/one-api-client';

    import IconCalendarMonth from '@keyvue/one-material-icons/icons/calendar_month.svg?component';
    import IconSchedule from '@keyvue/one-material-icons/icons/schedule.svg?component';
    import { formatDate, formatTime } from '@/utils/date';

    const props = defineProps<{
        appointment: Appointment | null,
    }>();

    const dateLabel = computed(() => (props.appointment ? formatDate(props.appointment.startDateTime) : ''));
    const timeLabel = computed(() => (props.appointment ? formatTime(props.appointment.startDateTime) : ''));
</script>
